import PropTypes from "prop-types";

import adresaPropTypes from "./adresaPropTypes";
import kontaktPropTypes from "./kontaktPropTypes";
import osobneUdajePropTypes from "./osobneUdajePropTypes";

const propTypes = {
  osoba: PropTypes.shape({
    osobneUdaje: osobneUdajePropTypes.osobneUdaje,
    adresa: adresaPropTypes.adresa,
    kontakt: kontaktPropTypes.kontakt,
  }),
};

export default propTypes;
